import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';
import { useAliveController } from 'react-activation';
import styles from './ForumDefault.module.less';
import { CONTEXT } from '../../../config';
import { logging } from '../../../actions/log';

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default function Shop() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { drop, refresh } = useAliveController();
  const userInfo = useSelector(selectUserInfo);
  const logInfoData = useSelector(selectLogInfo);

  useEffect(() => {
    // 获取并存下登录状态
    const login_status = window.CallNativeMethod('get_login_status');
    if (login_status === '1' && userInfo.st) {
      window.CallNativeMethod('login');
    }
  }, [userInfo]);

  const handleBtn = useCallback((page, type) => {
    drop(page);
    if (page === 'forumlist') {
      refresh(page);
    }

    dispatch(
      logging({
        category: 'C',
        action: 'Forum_Default_Change_Page',
        label: '',
        param2: {
          source: 'Forum_Default',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          page,
          type,
        },
      }),
    );
    let url = `${CONTEXT}/${page}`;
    if (page === 'formpublish') {
      url = `${CONTEXT}/${page}?type=${type}`;
    }
    setTimeout(() => {
      history.push(url);
    }, 50);
  }, []);

  const login_status = window.CallNativeMethod('get_login_status');
  if (!userInfo.st || login_status !== '1') {
    return (
      <div className={styles.forum}>
        <div className={styles.forum_img}></div>
        <div className={styles.forum_info}>
          <div className={styles.forum_text}>
            {location.pathname.indexOf('forumlistpublish') > -1 && `登录后，查看已发表的内容`}
            {location.pathname.indexOf('forumlistcollect') > -1 && `登录后，查看已收藏的内容`}
            {location.pathname.indexOf('forumdetail') > -1 && `登录后，查看帖子的内容`}
          </div>
        </div>
        <div
          className={styles.forum_btn_login}
          onClick={() => {
            window.CallNativeMethod('login');
          }}
        >
          登录
        </div>
      </div>
    );
  } else {
    return (
      <div className={styles.forum}>
        <div className={styles.forum_img}></div>
        <div className={styles.forum_info}>
          <div className={styles.forum_text}>
            {location.pathname.indexOf('forumlistpublish') > -1 && `啊哦，你还没有发表内容`}
            {location.pathname.indexOf('forumlistcollect') > -1 && `啊哦，你还没有已收藏内容`}
            {location.pathname.indexOf('forumdetail') > -1 && `啊哦，帖子已不存在`}
          </div>
          {(location.pathname.indexOf('forumlistcollect') > -1 ||
            location.pathname.indexOf('forumdetail') > -1) && (
            <div
              className={styles.forum_sea}
              onClick={() => {
                handleBtn('forumlist');
              }}
            >
              随便逛逛
            </div>
          )}
        </div>
        {location.pathname.indexOf('forumlistpublish') > -1 && (
          <div className={styles.forum_btns}>
            <div
              className={styles.forum_btn}
              onClick={() => {
                handleBtn('formpublish', '1');
              }}
            >
              去提问
            </div>
            <div
              className={styles.forum_btn}
              onClick={() => {
                handleBtn('formpublish', '2');
              }}
            >
              去分享
            </div>
          </div>
        )}
      </div>
    );
  }
}
